import * as React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useNavigate, useParams } from 'react-router-dom';
import { APP_QUERY } from 'const/queries';
import {
    LISTING_UPDATE,
    LISTING_DELETE,
    S3_UPLOAD_REQUEST,
    LISTING_IMAGE_DELETE,
} from 'const/mutations';
import { ListingFormView } from './view';
import { cleanPayload } from 'utils/formutils';
import { useEffect } from 'react';

export function ListingEditForm() {
    const navigate = useNavigate();
    const { id: appId, lid: listingId } = useParams<{ id: string; lid: string }>();
    const DASHBOARD_LINK = '/extranet/apps/' + appId + '/dashboard';

    const { data, refetch } = useQuery(APP_QUERY, {
        variables: { id: appId },
    });

    const app = data && data.app;
    // eslint-disable-next-line eqeqeq
    const listing = data?.app.listings.find(p => p.id == listingId);

    const [listingUpdate, { loading: saving }] = useMutation(LISTING_UPDATE, {
        onCompleted() {
            navigate(DASHBOARD_LINK);
            refetch();
        },
    });

    const [listingDelete, { loading: deleting }] = useMutation(LISTING_DELETE, {
        onCompleted() {
            navigate(DASHBOARD_LINK);
            refetch();
        },
    });

    const [listingDeleteImage, { loading: deletingImage }] = useMutation(LISTING_IMAGE_DELETE);

    const onSubmit = (values, form, callback) => {
        values.id = listingId;
        listingUpdate({ variables: cleanPayload(values) })
            .then(() => {
                callback();
            })
            .catch(err => callback(err));
    };

    const onDelete = () => {
        listingDelete({ variables: { id: listingId } });
    };

    const onCancel = () => {
        navigate(DASHBOARD_LINK);
    };

    const onDeleteImage = async (type, key, callback) => {
        await listingDeleteImage({
            variables: { id: listingId, imageType: type, imageKey: key },
        });
        if (callback !== undefined) {
            callback();
        }
    };

    const [s3UploadRequestMutation] = useMutation(S3_UPLOAD_REQUEST);

    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ListingFormView
            app={app}
            listing={listing}
            loading={saving}
            deleting={deleting}
            onCancel={onCancel}
            onSubmit={onSubmit}
            onDelete={onDelete}
            onDeleteImage={onDeleteImage}
            deletingImage={deletingImage}
            s3UploadRequestMutation={s3UploadRequestMutation}
        />
    );
}
